// ─────────────────────────────────────────────────────────────────────────────
// Ignore Codes Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the ignoreCodes store slice.
// Covers list, create, update, delete, bulk-delete, loading state, search, and
// filter actions.
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { IPageCount } from 'src/app/shared/models/page.model';
import { ICreateIgnoreCodePayload, IgnoreCodeFilters, IIgnoreCode, IUpdateIgnoreCodePayload } from '../models/ignore-code.models';

// ── Load ignore codes ───────────────────────────────────────────────────────

export const LoadIgnoreCodes = createAction(
  '[ IgnoreCodes ] - LoadIgnoreCodes',
  props<{ page: IPageCount; key?: string; filters?: IgnoreCodeFilters; sortBy?: string; sortMode?: 'asc' | 'desc' }>(),
);
export const LoadIgnoreCodesSuccess = createAction('[ IgnoreCodes ] - LoadIgnoreCodes Success ', props<{ response: APIResponse<IIgnoreCode> }>());
export const LoadIgnoreCodesError = createAction('[ IgnoreCodes ] - LoadIgnoreCodes Error');

// ── Create ignore code ──────────────────────────────────────────────────────

export const CreateIgnoreCode = createAction('[ IgnoreCode ] - CreateIgnoreCode', props<{ payload: ICreateIgnoreCodePayload }>());
export const CreateIgnoreCodeSuccess = createAction('[ IgnoreCode ] - CreateIgnoreCode Success ', props<{ ignoreCode: IIgnoreCode }>());
export const CreateIgnoreCodeError = createAction('[ IgnoreCode ] - CreateIgnoreCode Error', props<{ error: string }>());

// ── Update ignore code ──────────────────────────────────────────────────────

export const UpdateIgnoreCode = createAction('[ IgnoreCode ] - UpdateIgnoreCode', props<{ id: number; payload: IUpdateIgnoreCodePayload }>());
export const UpdateIgnoreCodeSuccess = createAction('[ IgnoreCode ] - UpdateIgnoreCode Success ', props<{ ignoreCode: IIgnoreCode }>());
export const UpdateIgnoreCodeError = createAction('[ IgnoreCode ] - UpdateIgnoreCode Error', props<{ error: string }>());

// ── Bulk delete ignore codes ────────────────────────────────────────────────

export const BulkDeleteIgnoreCodes = createAction('[ IgnoreCodes ] - BulkDeleteIgnoreCodes', props<{ ids: number[] }>());
export const BulkDeleteIgnoreCodesSuccess = createAction('[ IgnoreCodes ] - BulkDeleteIgnoreCodes Success ');
export const BulkDeleteIgnoreCodesError = createAction('[ IgnoreCodes ] - BulkDeleteIgnoreCodes Error');

// ── Loader ───────────────────────────────────────────────────────────────────

export const SetIgnoreCodesLoader = createAction('[ IgnoreCodes ] - SetLoading', props<{ isLoading: boolean }>());

// ── Search ───────────────────────────────────────────────────────────────────

export const SetIgnoreCodeSearch = createAction('[ IgnoreCodes ] - SetSearch', props<{ keyword: string }>());

// ── Filters ──────────────────────────────────────────────────────────────────

export const SetIgnoreCodeFilters = createAction('[ IgnoreCodes ] - SetFilters', props<{ filters: IgnoreCodeFilters }>());
